<wsd-extended-card
  [loading]="!(goodStanding$ | async)"
  [title]="'DATA_PORTAL.GOOD_STANDING.TITLE' | translate"
  [redirectTo]="['/organizations', organizationId, 'modify', 'detail']"
  [info]="!(goodStanding$ | async)?.goodStanding"
  (infoClicked)="modalVisible = !modalVisible">
  <div class="text-center m-t-15" *ngIf="goodStanding$ | async as data">
    <span [ngClass]="{'text-success': data.goodStanding, 'text-danger': !data.goodStanding}">
      <i [ngClass]="'fa status ' + (data.goodStanding ? 'fa-check-circle' : 'fa-exclamation-circle')"></i>
    </span>
  </div>
</wsd-extended-card>

<p-dialog
  [header]="'DATA_PORTAL.GOOD_STANDING.TITLE' | translate"
  [(visible)]="modalVisible">

  <div class="ui-g">
    <div class="ui-g-12">
      <label>
        {{'DATA_PORTAL.GOOD_STANDING.SUSPENSION_INFO' | translate}}
      </label>
    </div>
  </div>
  <div class="ui-g">
    <div class="ui-g-12">
      <p>{{(goodStanding$ | async)?.suspensionInformation}}</p>
    </div>
  </div>
  <div class="ui-g">
    <div class="ui-g-12">
      <label>
        <i class="fa fa-eye-slash primary-color"></i>
        {{'DATA_PORTAL.GOOD_STANDING.CONFIDENTIAL_SUSPENSION_INFO' | translate}}
      </label>
    </div>
  </div>
  <div class="ui-g">
    <div class="ui-g-12">
      <p>{{(goodStanding$ | async)?.confidentialInformation}}</p>
    </div>
  </div>
</p-dialog>
